import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { useLazyLoadQuery } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import ProjectCardLarge from "./ProjectCardLarge";
import { CircularProgress } from "@mui/material";
import Alert from "@mui/material/Alert";

const ProjectQuery = graphql`
    query ProjectQuery($slug: String!) {
        project(slug: $slug) {
            ...ProjectCardLarge_project
        }
    }
`;

function ProjectData({ slug }) {
    const data = useLazyLoadQuery(ProjectQuery, { slug });
    if (!data.project) {
        return <Alert severity="error" data-testid="errorButton">Project not found.</Alert>;
    }
    return <ProjectCardLarge projectRef={data.project} />;
}

function Project(_props) {
    const { slug } = useParams();
    return (
        <Suspense fallback={<CircularProgress data-testid="spinner" />}>
            <ProjectData slug={slug} />
        </Suspense>
    );
}

export default Project;
